import * as React from "react";
import { TabBar, TabSize, TabContent, IVssContributedTab, Tab } from "azure-devops-ui/Tabs";
import { Header, TitleSize } from "azure-devops-ui/Header";
import { IHeaderCommandBarItem } from "azure-devops-ui/HeaderCommandBar";
import { Page } from "azure-devops-ui/Page";
import { ObservableValue, ObservableArray } from "azure-devops-ui/Core/Observable";
import { FilterBar } from "azure-devops-ui/FilterBar";
import {
    InlineKeywordFilterBarItem,
    KeywordFilterBarItem
} from "azure-devops-ui/TextFilterBarItem";
import { DropdownFilterBarItem } from "azure-devops-ui/Dropdown";
import { Filter } from "azure-devops-ui/Utilities/Filter";
import { DropdownSelection } from "azure-devops-ui/Utilities/DropdownSelection";
import { Checkbox } from "azure-devops-ui/Checkbox";

import "./Page.Example.css";

const filter = new Filter();

const commandBarItemsFor1: IHeaderCommandBarItem[] = [
    {
        id: "create",
        text: "Create Project",
        onActivate: () => {
            alert("Create project");
        },
        iconProps: {
            iconName: "Add"
        },
        isPrimary: true
    }
];

const commandBarItemsFor2: IHeaderCommandBarItem[] = [
    ...commandBarItemsFor1,
    {
        id: "otherAction",
        text: "Action",
        onActivate: () => {
            alert("Action 2");
        }
    }
];

const renderFilterBar = (inTabBar: boolean) => {
    return inTabBar
        ? renderFilterBarInTabBar(selectedTabId1.value)
        : renderFilterBarInTabContent(selectedTabId1.value);
};

const renderFilterBarInTabBar = (selectedTabId: string) => {
    if (selectedTabId === "tab2") {
        return <InlineKeywordFilterBarItem filter={filter} filterItemKey="keyword" />;
    }
    return undefined;
};

const renderFilterBarInTabContent = (selectedTabId: string) => {
    if (selectedTabId === "tab4") {
        return (
            <FilterBar filter={filter}>
                <KeywordFilterBarItem filterItemKey="keyword" />
                <DropdownFilterBarItem
                    filterItemKey="picklist"
                    filter={filter}
                    items={[{ id: "Item 1", text: "Item 1" }, { id: "Item 2", text: "Item 2" }]}
                    selection={new DropdownSelection()}
                    placeholder="Dropdown"
                />
            </FilterBar>
        );
    }
    return undefined;
};

const selectedTabId1 = new ObservableValue<string>("tab2");
const selectedTabId2 = new ObservableValue<string>("tab5");

export default class PageWithProvidersExample extends React.Component<
    {},
    { useOtherTabProvider: boolean }
> {
    constructor(props: {}) {
        super(props);

        this.state = {
            useOtherTabProvider: false
        };
    }

    public render() {
        const selectedTabId = this.state.useOtherTabProvider ? selectedTabId2 : selectedTabId1;
        return (
            <div className="sample-page flex-column flex-grow">
                <Page
                    className="flex-grow"
                    selectedTabId={selectedTabId}
                    tabProviders={this.state.useOtherTabProvider ? providers2 : providers1}
                >
                    <Header title="Page Title" titleSize={TitleSize.Large} />
                    <TabBar tabSize={TabSize.Tall} onSelectedTabChanged={this.onSelectedTabChanged}>
                        <Tab id="tab1" name="Tab 1" />
                    </TabBar>
                    <TabContent>
                        {selectedTabId.value === "tab1" && (
                            <div className="page-content">Tab 1</div>
                        )}
                    </TabContent>
                </Page>
                <Checkbox
                    checked={this.state.useOtherTabProvider}
                    onChange={this.onCheckboxChange}
                    label="Use other tab provider"
                />
            </div>
        );
    }

    private onSelectedTabChanged = (newTabId: string) => {
        const selectedTabId = this.state.useOtherTabProvider ? selectedTabId2 : selectedTabId1;
        selectedTabId.value = newTabId;
    };

    private onCheckboxChange = (
        event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
        checked: boolean
    ) => {
        this.setState({ useOtherTabProvider: checked });
    };
}

const provider1Tabs = [
    {
        id: "tab4",
        name: "Tab 4",
        render: () => <div className="page-content">Tab 4</div>,
        renderFilterBar: renderFilterBar
    }
];

const provider2Tabs = [
    {
        id: "tab2",
        order: 10,
        name: "Tab 2",
        render: () => <div className="page-content">Tab 2</div>,
        renderFilterBar: renderFilterBar,
        commandBarItems: commandBarItemsFor1
    }
];

const provider3Tabs = [
    {
        id: "tab3",
        order: 20,
        name: "Tab 3",
        render: () => <div className="page-content">Tab 3</div>,
        renderFilterBar: renderFilterBar,
        commandBarItems: commandBarItemsFor2
    }
];

const provider4Tabs = [
    {
        id: "tab5",
        order: 20,
        name: "Tab 5",
        render: () => <div className="page-content">Tab 5</div>
    }
];
const provider5Tabs = [
    {
        id: "tab6",
        order: 20,
        name: "Tab 6",
        render: () => <div className="page-content">Tab 6</div>
    }
];

const providers1 = new ObservableArray<IVssContributedTab>();
setTimeout(() => {
    providers1.push(...provider1Tabs);
}, 100);
setTimeout(() => {
    providers1.push(...provider2Tabs);
}, 0);
setTimeout(() => {
    providers1.push(...provider3Tabs);
}, 300);

const providers2 = new ObservableArray<IVssContributedTab>();
setTimeout(() => {
    providers2.push(...provider4Tabs);
}, 100);
setTimeout(() => {
    providers2.push(...provider5Tabs);
}, 0);
